import { useEffect, useState } from "react";
import useToggle from "../../../shared/hook/useToggle";
import { GET } from "../../../utils/apiCalls";
import API from "../../../config/API";
import { Button } from "antd";
import FormModal from "./formModal";
import BusinessTypeTable from "./table";
import React from "react";

function BusinessType(props: any) {
  const [page, setPage] = useState(1);
  type ModalState = "add" | "update";
  const [businesstypeData, setBusinesstypeData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedItem, setSelectedItem] = useState<any>({});
  const [type, setType] = useState<ModalState>("add");
  const pageSize = 10;
  const [totalItems, setTotalItems] = useState<number>(0);
  const [toggle, toggleModal] = useToggle(false);
  const openModal = (item: any) => {
    setSelectedItem(item);
    toggleModal(true);
  };

  const getBusinesstypeData = async (page: number, pageSize: number) => {
    try {
      let url = API.BUSINESS_TYPE;
      let response: any = await GET(url, null);

      if (response.status) {
        const startIndex = (page - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        const pageData = response.data.slice(startIndex, endIndex);
        setBusinesstypeData(pageData);
        setTotalItems(response.data.length);
      } else {
        console.log("couldn't get the data");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    try {
      await getBusinesstypeData(page, pageSize);
    } catch (err) {
      console.log("error", err);
    }
  };
  
  useEffect(() => {
    let isMounted = true;

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [page, pageSize]);
  const receiveSelectedItem = (item: any) => {
    setSelectedItem(item);
  };

  const changePage = (newPage: number, pageSize: number) => {
    setPage(newPage);
    window.scrollTo(0, 0);
  };

  const fetchDataCallback = () => {
    getBusinesstypeData(page, pageSize);
  };

  return (
    <div>
      <Button
        onClick={() => {
          toggleModal(true);
          setType("add");
        }}
        type="primary"
      >
        Add BusinessType +
      </Button>
      <BusinessTypeTable
        data={businesstypeData}
        getBusinesstypeData={getBusinesstypeData}
        getBusinesstype={getBusinesstypeData}
        closeModal={() => toggleModal(false)}
        openModal={openModal}
        getSelectedItem={receiveSelectedItem}
        fetchDataCallback={fetchDataCallback}
        changeType={() => setType("update")}
        page={page}
        pageSize={pageSize}
        totalItems={totalItems}
        changePage={changePage}
      />

      <FormModal
        open={toggle}
        modalClose={() => {
          toggleModal(false);
        }}
        data={selectedItem}
        fetchDataCallback={fetchDataCallback}
        getBusinesstype={getBusinesstypeData}
        type={type}
        page={page}
      />
    </div>
  );
}
export default BusinessType;
